import { render, staticRenderFns } from "./ActivityForm.vue?vue&type=template&id=afc96562&"
import script from "./ActivityForm.vue?vue&type=script&lang=js&"
export * from "./ActivityForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('afc96562')) {
      api.createRecord('afc96562', component.options)
    } else {
      api.reload('afc96562', component.options)
    }
    module.hot.accept("./ActivityForm.vue?vue&type=template&id=afc96562&", function () {
      api.rerender('afc96562', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/kanban/components/ActivityForm.vue"
export default component.exports